import React from 'react';
import './Chapters.scss';
import tombstoneSymbol from '../../Assets/tombstoneSymbol.svg';

function Chapter5() {
  return (
    <>
      <section className="chapter" style={{ marginBottom: '1rem' }}>
        <h3 className="chapter__title">The Color of Change</h3>
        <p className="chapter__paragraph">
          All these changes herald the release of the key color for BASF’s North American market:
          Lava. With a deep charcoal gray base that reveals a glowing red tint when light flows over
          the surface,{' '}
          <a
            href="https://www.basf-coatings.com/global/en/shaping-the-future/driving_color_design/automotive_color_trends/NEW_ARRAY_2022_2023_color_collection.html"
            target="_blank"
            rel="sponsored"
          >
            Lava represents a fusion of technology and sustainability.
          </a>{' '}
          The complex depth found in Lava is nuanced and forward-thinking, representing the visions
          of progress flowing throughout society. It aligns with the increased popularity of gray
          hues in North America while hinting at the rising love for reds across all markets.
        </p>
        <p className="chapter__paragraph">
          The NEW ARRAY collection represents a shift in the ways people will express themselves
          through their cars. The automotive world is changing rapidly, and the colors you’ll see on
          the road will reflect that. Lava, and other colors from the NEW ARRAY palette, could hit
          dealerships within the next three to five model years — pushing the next generation of
          vehicles even further into the future.{' '}
          <span style={{ marginTop: '1rem' }}>
            <img
              src={tombstoneSymbol}
              alt=" basf tombstone symbol"
              style={{ position: 'relative', top: '1.5px', left: '2px' }}
            />
          </span>
        </p>
      </section>
    </>
  );
}

export default Chapter5;
